import React, { useState, useEffect } from 'react';
import { aboutService, legalFrameworkService } from '../services/api';
/* eslint-disable react-hooks/exhaustive-deps */

function About() {
  const [about, setAbout] = useState({
    introduction: '',
    specializedFields: [],
  });
  const [legalFramework, setLegalFramework] = useState({ content: '', image: '' });
  const [loading, setLoading] = useState(true);

  const parseJson = (value, fallback) => {
    if (!value) return fallback;
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : fallback;
    } catch (e) {
      return fallback;
    }
  };

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const [aboutResponse, legalResponse] = await Promise.all([
          aboutService.get(),
          legalFrameworkService.get(),
        ]);
        if (aboutResponse.data) {
          setAbout({
            introduction: aboutResponse.data.introduction || '',
            specializedFields: parseJson(aboutResponse.data.specializedFields, []),
          });
        }
        if (legalResponse.data) {
          setLegalFramework({
            content: legalResponse.data.content || '',
            image: legalResponse.data.image || '',
          });
        }
      } catch (error) {
        console.error('Error fetching about data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchAbout();
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">درباره نشریه مجری</h1>
          <p className="text-xl text-blue-100">نشریه علمی سازمان مجری ساختمانها و تأسیسات دولتی و عمومی</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Introduction */}
        <section className="bg-white rounded-xl shadow-md p-8 mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">معرفی</h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            {about.introduction}
          </p>
        </section>

        {/* Specializations */}
        <section className="mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-8">حوزه‌های تخصصی</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {about.specializedFields.length ? about.specializedFields.map((field, idx) => (
              <div key={idx} className="bg-white rounded-lg shadow-md p-6 flex items-start gap-3">
                <span className="text-2xl" role="img" aria-label="icon">{field.icon || '•'}</span>
                <div>
                  <h3 className="text-gray-900 font-bold">{field.title}</h3>
                  {field.description && <p className="text-gray-600 text-sm mt-1">{field.description}</p>}
                </div>
              </div>
            )) : (
              <p className="text-gray-500 col-span-3 text-center">اطلاعاتی برای نمایش وجود ندارد</p>
            )}
          </div>
        </section>

        {/* Legal Framework */}
        {legalFramework.content && (
          <section className="bg-white rounded-xl shadow-md p-8 mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">چهارچوب قانونی</h2>
            <p className="text-lg text-gray-700 leading-relaxed whitespace-pre-wrap">
              {legalFramework.content}
            </p>
            {legalFramework.image && (
              <img
                src={legalFramework.image}
                alt="چهارچوب قانونی"
                className="mt-6 rounded-lg shadow-md max-h-96 object-contain"
              />
            )}
          </section>
        )}
      </div>
    </div>
  );
}

export default About;
